(() => {
  const initialize = () => {
    const header = document.getElementById('Header');
    if (header && !header.dataset.lgMeasured) {
      header.dataset.lgMeasured = 'true';
      new ResizeObserver(() => document.documentElement.style.setProperty('--tg-header-height', header.offsetHeight + 'px')).observe(header);
    }
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('click', event => {
    document.querySelectorAll('.LgRefinedLocale__Disclosure[open]').forEach(detail => {
      if (!detail.contains(event.target)) detail.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.LgRefinedLocale__Disclosure[open]').forEach(detail => {
      detail.open = false;
      detail.querySelector('summary').focus();
    });
  });
})();

(() => {
  const overlaySelector = '.Drawer.Show,.Modal.Show,dialog[open],#docapp-gift-choice-modal-wrapper.docapp-visible';
  const clubSelector = '#smile-ui-lite-launcher-frame-container,.smile-launcher-frame-container';
  const controlSelector = 'button,input:not([type="hidden"]),select,textarea,summary,[role="button"],a.Button,.LgCatalog__Buy,.ProductForm__AddToCart,.ProductForm__Checkout,.shopify-payment-button,shopify-accelerated-checkout';
  const observedStateSelector = '#wfb-wrapper,.Drawer,.Modal,dialog,#docapp-gift-choice-modal-wrapper,' + clubSelector;
  const boundToggles = new WeakSet();
  let wrapper;
  let pending = false;

  const isVisible = element => {
    const bounds = element.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  };
  const intersects = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;

  const positionContacts = open => {
    const group = wrapper.querySelector('.wfb-buttons');
    let clearance = 0;
    if (open && group) {
      const bounds = group.getBoundingClientRect();
      const current = parseFloat(getComputedStyle(group).marginBottom) || 0;
      const unshifted = {left: bounds.left, right: bounds.right, top: bounds.top + current, bottom: bounds.bottom + current};
      document.querySelectorAll(clubSelector).forEach(element => {
        if (!isVisible(element)) return;
        const obstacle = element.getBoundingClientRect();
        if (intersects(unshifted, obstacle)) clearance = Math.max(clearance, unshifted.bottom - obstacle.top + 12);
      });
    }
    const value = Math.ceil(clearance) + 'px';
    if (wrapper.style.getPropertyValue('--lg-assistance-contact-clearance') !== value) wrapper.style.setProperty('--lg-assistance-contact-clearance', value);
  };

  const overlapsControls = toggle => {
    const bounds = toggle.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return false;
    if ([...document.querySelectorAll(clubSelector)].some(element => isVisible(element) && intersects(bounds, element.getBoundingClientRect()))) return true;
    const inset = 4;
    const xs = [bounds.left + inset, (bounds.left + bounds.right) / 2, bounds.right - inset];
    const ys = [bounds.top + inset, (bounds.top + bounds.bottom) / 2, bounds.bottom - inset];
    return xs.some(x => ys.some(y => document.elementsFromPoint(x, y).some(element => {
      if (wrapper.contains(element)) return false;
      const control = element.closest(controlSelector);
      return control && !wrapper.contains(control);
    })));
  };

  const update = () => {
    pending = false;
    const current = document.getElementById('wfb-wrapper');
    if (!current) { wrapper = null; return; }
    wrapper = current;
    const placement = {right: '16px', bottom: 'calc(16px + env(safe-area-inset-bottom, 0px))', 'z-index': '1000'};
    Object.entries(placement).forEach(([property, value]) => {
      if (wrapper.style.getPropertyValue(property) !== value || wrapper.style.getPropertyPriority(property) !== 'important') wrapper.style.setProperty(property, value, 'important');
    });
    const toggle = wrapper.querySelector('.wfb-toggle');
    if (!toggle) return;
    if (!boundToggles.has(toggle)) {
      boundToggles.add(toggle);
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-label', 'Assistenza clienti');
      toggle.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (!event.repeat) toggle.click();
      });
      toggle.addEventListener('click', schedule);
    }
    const open = wrapper.classList.contains('wfb-open');
    positionContacts(open);
    const expanded = String(open);
    if (toggle.getAttribute('aria-expanded') !== expanded) toggle.setAttribute('aria-expanded', expanded);
    const modalOpen = [...document.querySelectorAll(overlaySelector)].some(isVisible);
    const hidden = String(modalOpen || (!open && overlapsControls(toggle)));
    if (wrapper.dataset.lgAssistanceHidden !== hidden) wrapper.dataset.lgAssistanceHidden = hidden;
  };
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }
  const start = () => {
    schedule();
    document.addEventListener('scroll', schedule, {passive: true, capture: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('resize', schedule, {passive: true});
    document.addEventListener('transitionend', schedule, true);
    new MutationObserver(records => {
      if (records.some(record => record.type === 'childList' || record.target.matches(observedStateSelector))) schedule();
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'aria-hidden']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
